module.exports = __webpack_public_path__ + "img/9.476cab91.jpg";